module.exports = __webpack_public_path__ + "8808de6d.png";